
import {initWebComponent} from "@/helpers/web-component-helper";
import {DragZoom} from "ol/interaction";
import {
    getBySelector,
    hideElementsBySelector,
    isVisibleBySelector,
    showElementsBySelector
} from "@/helpers/element-helper.js";

const template = document.createElement('template');
template.innerHTML = `<footer-button data-title="Vergelijk kaarten" data-icon="fas fa-arrows-alt-h">`;

export class OlSliderComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            if (!getBySelector('.ol-control-small').classList.contains('d-none')) {
                hideElementsBySelector('.ol-control-small');
                hideElementsBySelector('#divBackgroundSwitcher');
            }

            if (isVisibleBySelector('layer-menu-compare')) {
                hideElementsBySelector('layer-menu-compare');
                this.firstChild.firstChild.classList.remove('active');
            } else {
                showElementsBySelector('layer-menu-compare');
                this.firstChild.firstChild.classList.add('active');
            }
        });
    }
}